import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { id: "problem", label: "The Problem" },
  { id: "solution", label: "Solution" },
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-4 z-50 px-4"
      data-testid="navbar"
    >
      <nav className="mx-auto flex max-w-5xl items-center justify-between rounded-full border border-white/10 bg-slate-950/80 py-2.5 pl-4 pr-2.5 backdrop-blur-xl">
        <Logo />
        <div className="hidden items-center gap-1 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="rounded-full px-4 py-2 text-sm text-slate-400 transition-colors duration-300 hover:bg-white/5 hover:text-slate-100"
            >
              {l.label}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <a
            href="#contact"
            onClick={go("contact")}
            data-testid="nav-cta-contact"
            className="group hidden items-center gap-1.5 rounded-full bg-purple-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-green-500 md:inline-flex"
          >
            Get in Touch
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <button
            data-testid="nav-menu-toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen(!open)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-slate-200 md:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.3 }}
            className="mx-auto mt-2 max-w-5xl rounded-3xl border border-white/10 bg-slate-950/95 p-4 backdrop-blur-xl md:hidden"
            data-testid="nav-mobile-menu"
          >
            {[...LINKS, { id: "contact", label: "Get in Touch" }].map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={go(l.id)}
                data-testid={`nav-mobile-link-${l.id}`}
                className="block rounded-2xl px-4 py-3 text-base text-slate-300 transition-colors hover:bg-white/5 hover:text-slate-50"
              >
                {l.label}
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navbar;
